module.exports = __webpack_public_path__ + "static/bowlAndShadow-f8d63ddbdc0902b723b10a26b5f5a097.png";